/* components/patterns/UserMenu.jsx — нижний блок сайдбара: пользователь + меню.
   Аватар/имя/лимит сообщений тарифа (вместо email), по клику Popover:
   Для бизнеса, Подарить Ресториум, Настройки, Выйти.
   «Поддержка» переехала в шапку раздела (SupportButton) и в «Ещё» на xs. */

import React from 'react';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { Icon } from '../ui/Icon.jsx';
import { Popover, PopoverItem } from '../ui/Popover.jsx';
import { RR } from '../../lib/router.jsx';

  const { useNavigate } = RR;

  // Имя в чипе сайдбара ограничиваем двумя словами (Фамилия Имя), чтобы длинное
  // ФИО («Ефремов Данила Алексеевич») не вылезало за пределы блока. Полное имя
  // остаётся в title по наведению.
  function twoWords(name) {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    return parts.slice(0, 2).join(' ');
  }

  function UserMenu() {
    const { user, logout, activeWorkspace } = useAuth();
    const toast = useToast();
    const navigate = useNavigate();
    if (!user) return null;

    const usage = activeWorkspace && activeWorkspace.usage;
    const limitText = usage ? (usage.limit != null ? usage.limit : '∞') : null;

    return (
      <Popover placement="top-start" width={260} trigger={
        <button className="user-menu" aria-label="Меню пользователя">
          <span className="user-menu__avatar">
            {user.avatar_url ? <img src={user.avatar_url} alt="" /> : user.initials}
          </span>
          <span className="user-menu__meta grow">
            <span className="user-menu__name truncate" title={user.full_name}>{twoWords(user.full_name)}</span>
            {usage
              ? <span className="user-menu__usage t-caption truncate" title={usage.label}>
                  <span className="num">{usage.used} / {limitText}</span> {usage.unit}
                </span>
              : <span className="user-menu__usage t-caption truncate">{user.email}</span>}
          </span>
          <Icon name="more-vertical" size={16} className="text-mute" />
        </button>
      }>
        {({ close }) => (
          <div className="stack stack-2">
            <PopoverItem icon="building" close={close} onClick={() => navigate('/settings?tab=business')}>Для бизнеса</PopoverItem>
            {/* Подарок — не настройка аккаунта, а покупка, поэтому пункт стоит
                до «Настроек», а не после: это действие, а не раздел. */}
            <PopoverItem icon="gift" close={close} onClick={() => navigate('/gift')}>Подарить Ресториум</PopoverItem>
            <PopoverItem icon="settings" close={close} onClick={() => navigate('/settings')}>Настройки</PopoverItem>
            <div className="popover__sep" />
            <PopoverItem icon="logout" danger close={close}
              onClick={() => { logout(); toast.show('Вы вышли из аккаунта', 'muted'); navigate('/signin'); }}>
              Выйти
            </PopoverItem>
          </div>
        )}
      </Popover>
    );
  }

export { UserMenu };
